import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteAttest = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}attest/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteAttest;
